import React from 'react'
import Seo from './common/Seo';
import Hero from './technologyService/Hero';
import VideoShowcase from './technologyService/VideoShowcase';
import AIServices from './technologyService/AIServices';
import SolutionLineup from './technologyService/SolutionLineup';
import ClosingCTA from './technologyService/ClosingCTA';

const TechnologyService = () => {
    return (
        <>
            <Seo
              title="기술 및 서비스"
              description="MT-ONE, MT-DF, MT-NOVA 등 MTST의 MES·AI 솔루션 라인업과 스마트공장 구축 기술을 소개합니다."
              path="/technology"
            />
            <VideoShowcase/>
            <Hero/>
            <AIServices/>
            <SolutionLineup/>
            <ClosingCTA/>
        </>
    );
}

export default TechnologyService
